import { PaginatedData } from '../types'
import { IQuizColor } from '../quizzes/types'

import { IUser } from 'src/store/models/user'

export interface CompletedQuiz {
  colors: IQuizColor
  createdAt: string
  deletedAt: string | null
  id: number
  imageUrl: string
  matchPercent: number
  public: boolean
  title: string
  updatedAt: string
}

export enum ConnectionStatus {
  approved = 'approved',
  requested = 'requested',
  denied = 'denied',
}

export interface ConnectionBase {
  id: number
  userId: string
  otherUserId: string
  status: ConnectionStatus
  matchPercent: number
  conversationId: string
  connectInitiatorUserId: string
  disconnectInitiatorUserId: null | string
  updatedAt: string
  deletedAt: null | string
  createdAt: string
}

export interface Connection extends ConnectionBase {
  otherUser: IUser & { completedQuizzes: CompletedQuiz[] }
}

export interface ConnectionListItem extends ConnectionBase {
  otherUser: IUser & { completedQuizzesCount: number }
}

export type ConnectionsResponse = PaginatedData<ConnectionListItem>
